import CloseIcon from "@icons/learning_adaptive_close.svg";
import CorrectIcon from "@icons/learning_adaptive_correct.svg";
import WrongIcon from "@icons/learning_adaptive_wrong.svg";
import KunduzLogo from "@icons/kunduzLogo.svg";
import styles from "./learningAdaptiveTestNavbar.module.scss";

export const LearningAdaptiveTestNavbar = (props: Props) => {
  const {
    isMobile,
    title,
    testInfo: { wrongCount, correctCount },
    handleBackButtonClicked,
  } = props;

  const onBackButtonClicked = () => handleBackButtonClicked();

  return (
    <div className={styles["container"]}>
      <div className={styles["logo"]}>
        <KunduzLogo />
      </div>
      {!isMobile && <div className={styles["title"]}>{title}</div>}
      <div className={styles["infoContainer"]}>
        <div className={styles["info"]}>
          <div className={styles["correct"]}>
            <CorrectIcon />
            <span>{correctCount}</span>
          </div>
          <div className={styles["wrong"]}>
            <WrongIcon />
            <span>{wrongCount}</span>
          </div>
        </div>
        <div className={styles["close"]} onClick={onBackButtonClicked}>
          <CloseIcon />
        </div>
      </div>
    </div>
  );
};

interface Props {
  isMobile: boolean;
  title: string;
  testInfo: {
    correctCount: number;
    wrongCount: number;
  };
  handleBackButtonClicked: () => void;
}
